import { createAction } from 'redux-act';

export const loadApplication = createAction('application/LOAD_APPLICATION');
